<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Детали клиента
    </h1>
    <div class="sub-nav">
      <a class="btn btn-default btn-sm" @click="smartBackButton('all-clients')">← Назад к Клиентам</a>
    </div>

    <clientDetail :client-id="$route.params.client_id" />

  </div>
</template>

<script>
import helpers from '@/helpers'
import clientDetail from '@/components/details/client/ClientDetail'

export default {
  name: 'client-details',
  components: { clientDetail },
  methods: {
    smartBackButton: helpers.smartBackButton
  }
}
</script>


// WEBPACK FOOTER //
// ClientDetails.vue?5b8e06e4